import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import UpgradeNotice from '../../shared/UpgradeNotice';

const AssignedTransactionsUpgradeNotice = () => (
    <Box
        sx={{
            py: { xs: 6, md: 10 },
            px: 2,
            background: 'linear-gradient(135deg, rgba(255,165,0,0.12) 0%, rgba(0,0,0,0.06) 100%)',
            minHeight: '100vh',
        }}
    >
        <Container maxWidth="md">
            <Stack spacing={2} alignItems="flex-start">
                <Typography variant="h4" fontWeight={800}>
                    Zugeordnete Vorgänge
                </Typography>
                <Typography color="text.secondary">
                    Der Zahlungsabgleich ist Teil des Buchhaltungstarifs.
                </Typography>
                <UpgradeNotice
                    title="Zahlungsvorgänge freischalten"
                    description="Schalte den Buchhaltungstarif frei, um Zuordnungen einzusehen."
                    actionLabel="Zum Buchhaltungstarif"
                />
            </Stack>
        </Container>
    </Box>
);

export default AssignedTransactionsUpgradeNotice;
